import { InputAdornment, TextField } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";

export function PhoneInput(props) {
  const {
    id,
    label,
    value,
    required,
    style,
    error,
    onClick,
    onChange,
    col,
    icon,
    inputedit,
    InputProps,
    buttonEnd,
    disabled,
    iconposition,
    size,
    ...rest
  } = props;

  const handleChanges = (event) => {
    const newEvent = { ...event };
    newEvent.target.value = formatPhoneNumber(event.target.value);
    if (onChange && typeof onChange === "function") {
      onChange(newEvent);
    }
  };

  let inputProps = {
    id: id,
    inputRef: formatPhoneNumber(rest.inputRef),
    required: required,
    disabled: disabled,
    onClick: onClick,
    inputedit: inputedit,
    error: error,
    col: col,
    ...style,
  };

  if (!rest.inputRef) {
    inputProps = { ...inputProps, value: formatPhoneNumber(value) };
  }

  return (
    <TextField
      label={label}
      variant="outlined"
      size={size || "small"}
      onChange={(event) => handleChanges(event)}
      {...inputProps}
      {...rest}
      slotProps={{
        input: {
          ...InputProps,
          startAdornment:
            icon && iconposition !== "end" ? <InputAdornment position="start">{icon}</InputAdornment> : undefined,
          endAdornment:
            icon && iconposition === "end" ? (
              <InputAdornment position="end">{icon}</InputAdornment>
            ) : buttonEnd ? (
              <InputAdornment position="end" sx={{ position: "absolute", right: "6px" }}>
                {buttonEnd}
              </InputAdornment>
            ) : undefined,
        }
      }} />
  );
}
